// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"c93271e1","366":"a3055593","514":"e6f84acd"}[chunkId] + ".chunk.js";
};